import { Result } from '../../tracking-api';

export type SuspendDataStoreError = {
  code: 'sync-error',
  details: unknown
} | {
  code: 'serialization-error',
  details: unknown
}

export const SuspendDataStoreSymbol = Symbol.for('SuspendDataStore');
export interface SuspendDataStore<T> {
  get2(key: keyof T): Promise<Result<T[keyof T] | null, SuspendDataStoreError>>;
  update2(key: keyof T, data: T[keyof T]): Promise<Result<true, SuspendDataStoreError>>;
}
